/**
 * Brand Explorer JavaScript
 * 使用 bex7d9j_ 前缀避免与其他脚本冲突
 */

(function() {
  // 确保 DOM 加载完毕后运行
  document.addEventListener('DOMContentLoaded', initBrandExplorer);
  
  // 检测是否为移动设备
  function isMobileDevice() {
    return window.innerWidth < 769; // 与CSS媒体查询保持一致
  }

  function initBrandExplorer() {
    console.log('初始化品牌探索组件'); // 调试信息
    initFollowButtons();
    
    // 只在移动设备上初始化滚动功能
    if (isMobileDevice()) {
      console.log('检测到移动设备，启用滚动功能');
      initProductsScroll();
      // 移除导航按钮初始化，因为手机版不需要导航按钮
    }
    
    // 监听窗口大小变化，动态调整功能
    window.addEventListener('resize', handleResize);
  }
  
  // 处理窗口大小变化
  function handleResize() {
    const isMobile = isMobileDevice();
    const scrollElements = document.querySelectorAll('.bex7d9j_products-scroll');
    
    scrollElements.forEach(scroll => {
      if (isMobile) {
        // 移动设备模式
        if (!scroll.classList.contains('mobile-initialized')) {
          initProductsScroll();
          // 移除导航按钮初始化
          scroll.classList.add('mobile-initialized');
        }
      } else {
        // 桌面模式
        scroll.classList.remove('mobile-initialized');
      }
    });
  }

  /**
   * 初始化关注按钮功能
   */
  function initFollowButtons() {
    const followButtons = document.querySelectorAll('.bex7d9j_follow-btn');
    
    followButtons.forEach(button => {
      button.addEventListener('click', () => {
        // 获取按钮上的品牌名称
        const brandName = button.getAttribute('data-brand-name');
        
        // 直接跳转，无需交互特效和延迟
        if (brandName) {
          window.location.href = `/pages/brand?brand=${encodeURIComponent(brandName)}`;
        }
      });
    });
  }
  
  /**
   * 初始化产品滚动区域的拖动功能
   */
  function initProductsScroll() {
    const productScrolls = document.querySelectorAll('.bex7d9j_products-scroll');
    
    productScrolls.forEach(scroll => {
      // 变量声明
      let startX;
      let scrollLeft;
      let isDown = false;

      // 触控事件 (移动设备)
      scroll.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX - scroll.offsetLeft;
        scrollLeft = scroll.scrollLeft;
      });
      
      scroll.addEventListener('touchmove', (e) => {
        if (!startX) return;
        const x = e.touches[0].clientX - scroll.offsetLeft;
        const walk = (x - startX) * 2; // 滚动速度
        scroll.scrollLeft = scrollLeft - walk;
      }, { passive: true });
      
      scroll.addEventListener('touchend', () => {
        startX = null;
      });

      // 鼠标拖拽滚动 (移动设备可能也支持鼠标)
      scroll.addEventListener('mousedown', (e) => {
        isDown = true;
        scroll.classList.add('grabbing');
        startX = e.pageX - scroll.offsetLeft;
        scrollLeft = scroll.scrollLeft;
        e.preventDefault();
      });
      
      scroll.addEventListener('mouseleave', () => {
        isDown = false;
        scroll.classList.remove('grabbing');
      });
      
      scroll.addEventListener('mouseup', () => {
        isDown = false;
        scroll.classList.remove('grabbing');
      });
      
      scroll.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scroll.offsetLeft;
        const walk = (x - startX) * 2; // 滚动速度
        scroll.scrollLeft = scrollLeft - walk;
      });
    });
  }
  
  /**
   * 导航按钮功能（仅用于桌面版）
   * 手机版不再使用此功能，因为用户可以直接滑动
   */
  function initNavButtons() {
    // 导航按钮功能已不再需要
  }
})(); 